/**
 * Uniap design system — public surface.
 *
 * Ported 1:1 from the Claude Design bundle
 * `_ds/uniap-design-system-8776f226-a530-4a51-bcf2-f59c46e66fea/_ds_bundle.js`
 * (namespace `UniapDesignSystem_8776f2`). Class names, CSS and props are
 * unchanged; the bundle's runtime `injectCss()` calls are replaced by real CSS
 * files so Vite can extract and minify them.
 */
export { Button } from './components/Button.jsx'
export { IconButton } from './components/IconButton.jsx'
export { Badge } from './components/Badge.jsx'
export { Tag } from './components/Tag.jsx'
export { Card } from './components/Card.jsx'
export { Icon } from './components/Icon.jsx'
export { Input } from './components/Input.jsx'
export { Select } from './components/Select.jsx'
export { Checkbox } from './components/Checkbox.jsx'
export { Switch } from './components/Switch.jsx'
export { Tabs } from './components/Tabs.jsx'
export { Accordion } from './components/Accordion.jsx'
export { LangSwitch } from './components/LangSwitch.jsx'
export { LANGUAGES, LANG_LABELS, LANG_NATIVE_NAMES } from './components/languages.js'
export { DeadlineNote } from './components/DeadlineNote.jsx'
